module.exports = __webpack_public_path__ + "static/img/addIcon.c2075901.png";